type TrackParams = Record<string, string | number | boolean>;

// GA4 is injected by the Rails layout only when GA4_MEASUREMENT_ID is set;
// without it this is a silent no-op, so call sites never need to guard.
export function track(event: string, params: TrackParams = {}): void {
  const gtag = (window as { gtag?: (...args: unknown[]) => void }).gtag;
  gtag?.('event', event, params);
}
